import React from 'react';
import {
    FaRocket,
    FaShieldAlt,
    FaCheckCircle,
    FaHeadset,
    FaChartLine,
    FaClipboardCheck
} from 'react-icons/fa';

const Features = () => {
    const features = [
        {
            title: 'Zero Downtime',
            description: 'Keep your business running throughout the entire migration process.',
            icon: FaRocket
        },
        {
            title: 'Complete Security',
            description: 'Enterprise-grade security with full encryption and compliance.',
            icon: FaShieldAlt
        },
        {
            title: 'Data Integrity',
            description: '100% data accuracy with validation at every step.',
            icon: FaCheckCircle
        },
        {
            title: 'Expert Support',
            description: '24/7 support from certified Microsoft specialists.',
            icon: FaHeadset
        },
        {
            title: 'Business Continuity',
            description: 'Comprehensive BC planning via our integrated platform.',
            icon: FaClipboardCheck
        },
        {
            title: 'Transparent Tracking',
            description: 'Real-time migration status and progress reporting.',
            icon: FaChartLine
        }
    ];

    return (
        <section className="py-12 md:py-16 bg-white">
        <div className="container-width">
        <div className="text-center mb-14">
        <h2 className="text-3xl md:text-4xl font-light text-primary-900 mb-4">
        Why Choose Our Migration Services
        </h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
        We handle complex migrations for enterprises of all sizes with proven methodology and tools
        </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
                <div key={index} className="group hover:shadow-md transition-shadow duration-300 p-6 rounded-lg border border-gray-100">
                <div className="mb-4">
                <IconComponent className="text-3xl text-primary-500" />
                </div>
                <h3 className="text-xl font-medium text-primary-800 mb-2">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                </div>
            );
        })}
        </div>
        </div>
        </section>
    );
};

export default Features;
